export { CmxSlideToggleComponent } from './cmx-slide-toggle.component';
